import { Sentry } from '@datacamp/exercise-monitoring';
import { SENTRY_DSN } from '../config';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const sentry = new Sentry(SENTRY_DSN);